import { getDeployEnv, isProductionEnv } from "./globals.mjs";
//#region src/helpers/googleMaps.ts
var getAddressInputUrl = () => {
	if (isProductionEnv() || getDeployEnv() === "localdev") return "/_address-input";
	return "https://demo.simplersell.com/_address-input";
};
var ADDRESS_INPUT_URL = getAddressInputUrl();
var ALLOWED_TYPES = [
	"street_address",
	"premise",
	"subpremise",
	"route"
];
var generateGoogleMapsSessionToken = () => {
	return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
};
var buildAutocompleteUrl = (query, sessionToken) => {
	return `${ADDRESS_INPUT_URL}/autocomplete?sessionToken=${sessionToken}&query=${query}`;
};
var buildCityAutocompleteUrl = (query, sessionToken) => {
	return `${ADDRESS_INPUT_URL}/autocomplete?sessionToken=${sessionToken}&query=${encodeURIComponent(query)}&types=(regions)`;
};
var buildPlacesUrl = ({ source, placeId, addressToken, sessionToken }) => {
	const baseUrl = `${ADDRESS_INPUT_URL}/place`;
	if (source === "casa") return baseUrl + `?addressToken=${addressToken}`;
	return baseUrl + `?sessionToken=${sessionToken}&placeId=${placeId}`;
};
//#endregion
export { ALLOWED_TYPES, buildAutocompleteUrl, buildCityAutocompleteUrl, buildPlacesUrl, generateGoogleMapsSessionToken };

//# sourceMappingURL=googleMaps.mjs.map